import React from 'react';
import { UIText1 } from '@cian/ui-kit';

import { SidebarTip } from './SidebarTip';
import { FolderDrawer } from '../Images';
import * as s from './SidebarTips.css';

/**
 * Карточка "Основные правила публикации" в сайдбаре
 */
export const SidebarPostPublicationRules = () => {
  const items = [
    'Материал должен давать пользу: объяснять, разбирать, сравнивать',
    'Используйте подзаголовок каждые 1–2 абзаца',
    'Блоки должны быть логично выстроены',
    'В конце — короткий вывод или рекомендация',
    'Не используйте сложные конструкции, канцеляриты и жаргон',
    'Приводите достоверные данные',
  ];

  return (
    <SidebarTip title="Основные правила" image={<FolderDrawer />}>
      <ul className={s['items-wrapper']}>
        {items.map((item, index) => (
          <li key={index}>
            <UIText1>{item}</UIText1>
          </li>
        ))}
      </ul>
    </SidebarTip>
  );
};
